// extracted by mini-css-extract-plugin
module.exports = {"PosPaid":"PosPaid_PosPaid__hX1Ur","backButton":"PosPaid_backButton__1W9Uf","readCard":"PosPaid_readCard__1vagb","content":"PosPaid_content__1z541"};